import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "my-tasks-panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_6 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 3,
  class: "tasks-container"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "project-title" }
const _hoisted_10 = { class: "task-count" }
const _hoisted_11 = { class: "tasks-list" }
const _hoisted_12 = { class: "task-info" }
const _hoisted_13 = { class: "task-name" }
const _hoisted_14 = { class: "task-dates" }
const _hoisted_15 = { class: "task-progress" }
const _hoisted_16 = { class: "progress-bar" }
const _hoisted_17 = { class: "progress-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Minhas Tarefas", -1)),
        _createElementVNode("p", _hoisted_3, "Tarefas em andamento hoje — " + _toDisplayString(_ctx.todayLabel), 1)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "Carregando tarefas...", -1)
        ]))]))
      : (_ctx.projects.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("p", null, "Nenhum projeto disponivel.", -1)
          ]))]))
        : (_ctx.allTodayTasks.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "Nenhuma tarefa para hoje.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksByProject, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.projectId,
                  class: "project-section"
                }, [
                  _createElementVNode("div", {
                    class: "project-header",
                    onClick: ($event: any) => (_ctx.$emit('view-project', group.projectId)),
                    role: "button",
                    tabindex: "0"
                  }, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(group.projectName), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(group.tasks.length) + " tarefa" + _toDisplayString(group.tasks.length !== 1 ? 's' : ''), 1)
                  ], 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tasks, (task) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: task.id,
                        class: "task-row"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(task.title), 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(task.plannedStart)) + " — " + _toDisplayString(_ctx.formatDate(task.plannedEnd)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "progress-fill",
                              style: _normalizeStyle({ width: _ctx.taskProgress(task) + '%' })
                            }, null, 4)
                          ]),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.taskProgress(task)) + "%", 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
  ]))
}